/** @jsx jsx */
import React, { forwardRef, type HTMLProps } from 'react';
import { token } from '@atlaskit/tokens';
import { cssMap, jsx } from '@atlaskit/css';
import { useIntl } from '@atlassian/jira-intl';
import { fg } from '@atlassian/jira-feature-gating';
import { COMMAND_CONTAINER_ROW_TEST_ID, COMPAL_MENU_ITEM_ID } from '../constants.tsx';
import { messages } from './messages.tsx';

const styles = cssMap({
	root: {
		paddingInlineStart: token('space.050'),
		paddingInlineEnd: token('space.050'),
	},
});

export type ListItemProps = {
	id?: string;
	active?: boolean;
	selected?: boolean;
};

export const CommandPaletteSearchResultListItem = forwardRef<
	HTMLDivElement,
	HTMLProps<HTMLDivElement> & ListItemProps
>(({ id, active, selected, ...rest }, ref) => {
	const { formatMessage } = useIntl();
	return (
		<div
			ref={ref}
			data-testid={COMMAND_CONTAINER_ROW_TEST_ID}
			role="option"
			aria-selected={selected}
			id={`${COMPAL_MENU_ITEM_ID}-${id}`}
			aria-label={formatMessage(messages.resultListItemAriaLabel)}
			{...(fg('dee-8683-compal-a11y-button-keyboard-accessibility') && {
				css: styles.root,
			})}
			{...rest}
		/>
	);
});
